module.exports = __webpack_public_path__ + "img/tucson.c74834f0.png";